import React, { useRef, useState } from 'react';
import ExtendClock from "../../../assets/image/ExtendClock.svg";
import { getValueFromResource } from '../../../common/timeLiveFunction';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import ExtendModal from './ExtendModal';
import { useNavigate } from 'react-router-dom';

const LicenseActivationPage = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { reviewurl } = useAppSelector((state) => state.globalState);
    const userRole = localStorage.getItem("ma_rid");
    const isFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");

    const renderDescription = (user: any) => {
        if (user === '1') {
            // return <p className="mb-2 text-gray-400">{getValueFromResource('We’d love your feedback - share a quick review to help us grow. Then, renew your subscription to keep the good times going without missing a beat.', dispatch, t)}</p>
            return <p className="mb-2 text-gray-400 text-center">{getValueFromResource(isFreeLicenseExpired == 'true' ? `To regain access, please choose a subscription plan. Need more time? Leave us a review and send a screenshot to sales@livetecs.com to extend your trial.` : 'To regain access to your account and continue using TimeLive, please renew your subscription.', dispatch, t)}</p>

        } else {
            return <p className="mb-2 text-gray-400 text-center">{getValueFromResource('Please contact your TimeLive administrator to restore access to your account.', dispatch, t)}</p>
        }
    }

    const renderHeading = (user: any) => {
        if (user === '1') {
            return <h4 className="mb-2">{getValueFromResource('Your TimeLive Subscription Has Been Expired', dispatch, t)}</h4>
        } else {
            return <h4 className="mb-2">{getValueFromResource('Your TimeLive Subscription Has Been Expired', dispatch, t)}</h4>
        }
    }

    return (
        <>
            <div className="d-flex flex-column justify-content-center align-items-center">
                {ExtendClock && (
                    <>
                        {/* <img src={ExtendClock} alt="extend clock" style={{height:'30%', width:'30%'}}/> */}
                        <img
                            src={ExtendClock}
                            alt="extend clock"
                            className="img-fluid"
                            style={{ maxWidth: 'min(100%, 30%)', height: 'auto' }}
                        />
                        {renderHeading(userRole)}
                        {renderDescription(userRole)}
                        {userRole === '1' && (
                            <div className="d-flex gap-2 mb-5">
                                <button
                                    className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    type='button'
                                    onClick={() => navigate('/licenseactivation')}
                                >
                                    {getValueFromResource(isFreeLicenseExpired == 'true' ? 'Choose Plan' : 'Renew Subscription', dispatch, t)}
                                </button>
                                {isFreeLicenseExpired == 'true' && <button
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm fs-7"
                                    onClick={() => window.open(reviewurl, '_blank')}
                                >
                                    {getValueFromResource('Extend Trial', dispatch, t)}
                                </button>}
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    )
}

export default LicenseActivationPage